var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'--body-font-family': ("'" + _vm.fontFamily + "'")}),attrs:{"id":"app"}},[_c('router-view'),_c('transition',{attrs:{"name":"abbi-fade"}},[(!_vm.styled)?_c('Loader'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }